@use 'style/utils';

:host {
    /**
     * @prop --form-error-color: color for the error text
     */
    --form-error-color: var(--joy-color-error-50);

    color: var(--form-error-color);
    @include utils.getFontProperties(primary-300);
}

:host(.joy-form-error) {
    display: none;
}

:host(.joy-has-error) {
    display: flex;
    margin-bottom: var(--joy-core-spacing-5);
    margin-top: 0;
    align-items: flex-start;
}


.joy-icon-error {
    margin-right: 10px;
    color: var(--joy-color-error-50);

    svg {
        color: var(--form-error-color);
    }
}

::slotted(ul), ::slotted(ul) {
    padding: 0;
    list-style: none;
    margin: 0;
}